import {
  Card,
  FormControl,
  Grid,
  Box,
  Button,
  IconButton,
  InputBase,
  Popover,
  TextField,
  Typography,
  MenuItem,
  Select,
  // InputLabel,
} from '@mui/material';
import { useLocation, useNavigate } from 'react-router-dom';
// import SearchIcon from '@mui/icons-material/Search';
import CloseIcon from '@mui/icons-material/Close';
import React, { useState, useEffect } from 'react';
import TuneIcon from '@mui/icons-material/Tune';
import { useMenu } from './../hooks/useMenu';
import { styled } from '@mui/material/styles';
import IconLib from './IconLib';
import { useTheme } from "../style/theme";

const SearchWrapper = styled('div')(({ theme }) => ({
  position: 'relative',
  marginLeft: 0,
  width: '100%',
  maxWidth: '720px',
  display: 'flex',
  alignItems: 'center',
  backgroundColor: theme.palette.custom.search.main,
  border: 'none',
  borderRadius: '20px',
}));

const IconWrapperLeft = styled('div')(({ theme }) => ({
  padding: theme.spacing(0, 2),
  height: '100%',
  position: 'absolute',
  pointerEvents: 'none',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  zIndex: 10,
}));

const IconWrapperRight = styled('div')(({ theme }) => ({
  padding: theme.spacing(0, 1),
  height: '100%',
  position: 'absolute',
  right: 0,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  zIndex: 10,
}));

const StyledInputBase = styled(InputBase)(({ theme }) => ({
  color: 'inherit',
  width: '100%',
  '& .MuiInputBase-input': {
    padding: theme.spacing(1, 1, 1, 0),
    [theme.breakpoints.up('sm')]: {
      padding: theme.spacing(1.5, 1, 1.5),
      paddingLeft: `calc(1em + ${theme.spacing(4)})`,
    },
    paddingLeft: `calc(1em + ${theme.spacing(4)})`,
    transition: theme.transitions.create('width'),
    width: '100%',
    '&:focus': {
      backgroundColor: theme.palette.custom.search.focus,
      boxShadow: 'rgba(0, 0, 0, 0.24) 0px 1px 3px',
      borderRadius: '20px',
    },
  },
}));



const FilterBox = ({ initialFilters, onFiltersChange, closeFilter }) => {
  const [type, setType] = useState(initialFilters.type);
  const [ownerType, setOwnerType] = useState(initialFilters.ownerType);
  const [specificOwner, setSpecificOwner] = useState(initialFilters.specificOwner);
  const [itemName, setItemName] = useState(initialFilters.itemName);
  const [location, setLocation] = useState(initialFilters.location);
  const [dateModified, setDateModified] = useState(initialFilters.dateModified);
  const [dateFrom, setDateFrom] = useState(initialFilters.dateFrom);
  const [dateTo, setDateTo] = useState(initialFilters.dateTo);

  const handleReset = () => {
    const resetFilters = {
      type: "any",
      ownerType: "anyone",
      specificOwner: "",
      itemName: "",
      location: "anywhere",
      dateModified: "anytime",
      dateFrom: "",
      dateTo: ""
    };
    setType(resetFilters.type);
    setOwnerType(resetFilters.ownerType);
    setSpecificOwner(resetFilters.specificOwner);
    setItemName(resetFilters.itemName);
    setLocation(resetFilters.location);
    setDateModified(resetFilters.dateModified);
    setDateFrom(resetFilters.dateFrom);
    setDateTo(resetFilters.dateTo);
    onFiltersChange(resetFilters);

    closeFilter();

  };

  const handleApply = () => {
    const filters = {
      type,
      ownerType,
      specificOwner,
      itemName,
      location,
      dateModified,
      dateFrom,
      dateTo,
    };
    onFiltersChange(filters);
    console.log("Applied Filters:", filters);
    closeFilter();
  };


  return (
    <Card
      sx={{
        p: 2.5,
        width: 500,
        height: 600,
        backgroundColor: "background.default",
        boxShadow: "0px 4px 20px rgba(0,0,0,0.15)",
        borderRadius: "12px",
        display: "flex",
        flexDirection: "column",
      }}
    >
      {/* Scrollable content area */}
      <Box sx={{
        flex: 1,
        overflowY: "auto",
        mb: 2,
        pr: 1, // Add some padding to prevent scrollbar overlap
        '&::-webkit-scrollbar': {
          width: '6px',
        },
        '&::-webkit-scrollbar-thumb': {
          backgroundColor: 'rgba(0,0,0,0.2)',
          borderRadius: '3px',
        },
      }}>
        <Grid container spacing={2}>
          {/* Type */}
          <Grid item xs={12}>
            <Typography variant="body2" sx={{ mb: 0.5, fontWeight: 500 }}>
              Type
            </Typography>
            <FormControl fullWidth size="small">
              <Select
                value={type}
                onChange={(e) => setType(e.target.value)}
                sx={{ fontSize: '14px' }}
              >
                <MenuItem value="any" sx={{ fontSize: '14px' }}>Any</MenuItem>
                <MenuItem value="image" sx={{ fontSize: '14px' }}>Image</MenuItem>
                <MenuItem value="video" sx={{ fontSize: '14px' }}>Video</MenuItem>
                <MenuItem value="document" sx={{ fontSize: '14px' }}>Document</MenuItem>
                <MenuItem value="file" sx={{ fontSize: '14px' }}>File</MenuItem>
                <MenuItem value="folder" sx={{ fontSize: '14px' }}>Folder</MenuItem>
                <MenuItem value="audio" sx={{ fontSize: '14px' }}>Audio</MenuItem>
                <MenuItem value="archive" sx={{ fontSize: '14px' }}>Archive</MenuItem>
              </Select>
            </FormControl>
          </Grid>

          {/* Owner */}
          <Grid item xs={12}>
            <Typography variant="body2" sx={{ mb: 0.5, fontWeight: 500 }}>
              Owner
            </Typography>
            <FormControl fullWidth size="small">
              <Select
                value={ownerType}
                onChange={(e) => setOwnerType(e.target.value)}
                sx={{ fontSize: '14px' }}
              >
                <MenuItem value="anyone" sx={{ fontSize: '14px' }}>Anyone</MenuItem>
                <MenuItem value="me" sx={{ fontSize: '14px' }}>Owned by me</MenuItem>
                <MenuItem value="not_me" sx={{ fontSize: '14px' }}>Not owned by me</MenuItem>
                <MenuItem value="specific" sx={{ fontSize: '14px' }}>Specific person</MenuItem>
              </Select>
            </FormControl>
          </Grid>

          {ownerType === "specific" && (
            <Grid item xs={12}>
              <Typography variant="body2" sx={{ mb: 0.5, fontWeight: 500 }}>
                Name or Email
              </Typography>
              <TextField
                fullWidth
                size="small"
                placeholder="Name or Email"
                value={specificOwner}
                onChange={(e) => setSpecificOwner(e.target.value)}
                sx={{
                  '& input': {
                    fontSize: '14px',
                    py: 1,
                  },
                  '& .MuiOutlinedInput-root': {
                    fontSize: '14px',
                  }
                }}
              />
            </Grid>
          )}

          {/* Item Name */}
          <Grid item xs={12}>
            <Typography variant="body2" sx={{ mb: 0.5, fontWeight: 500 }}>
              Item name
            </Typography>
            <TextField
              fullWidth
              size="small"
              placeholder="Item name"
              value={itemName}
              onChange={(e) => setItemName(e.target.value)}
              sx={{
                '& input': {
                  fontSize: '14px',
                  py: 1,
                },
                '& .MuiOutlinedInput-root': {
                  fontSize: '14px',
                }
              }}
            />
          </Grid>

          {/* Location */}
          <Grid item xs={12}>
            <Typography variant="body2" sx={{ mb: 0.5, fontWeight: 500 }}>
              Location
            </Typography>
            <FormControl fullWidth size="small">
              <Select
                value={location}
                onChange={(e) => setLocation(e.target.value)}
                sx={{ fontSize: '14px' }}
              >
                <MenuItem value="anywhere" sx={{ fontSize: '14px' }}>Anywhere</MenuItem>
                <MenuItem value="my_drive" sx={{ fontSize: '14px' }}>My Drive</MenuItem>
                <MenuItem value="shared_with_me" sx={{ fontSize: '14px' }}>Shared with me</MenuItem>
              </Select>
            </FormControl>
          </Grid>

          {/* Date Modified */}
          <Grid item xs={12}>
            <Typography variant="body2" sx={{ mb: 0.5, fontWeight: 500 }}>
              Date modified
            </Typography>
            <FormControl fullWidth size="small">
              <Select
                value={dateModified}
                onChange={(e) => setDateModified(e.target.value)}
                sx={{ fontSize: '14px' }}
              >
                <MenuItem value="anytime" sx={{ fontSize: '14px' }}>Anytime</MenuItem>
                <MenuItem value="today" sx={{ fontSize: '14px' }}>Today</MenuItem>
                <MenuItem value="yesterday" sx={{ fontSize: '14px' }}>Yesterday</MenuItem>
                <MenuItem value="last_7" sx={{ fontSize: '14px' }}>Last 7 days</MenuItem>
                <MenuItem value="last_30" sx={{ fontSize: '14px' }}>Last 30 days</MenuItem>
                <MenuItem value="last_90" sx={{ fontSize: '14px' }}>Last 90 days</MenuItem>
                <MenuItem value="custom" sx={{ fontSize: '14px' }}>Custom</MenuItem>
              </Select>
            </FormControl>
          </Grid>

          {dateModified === "custom" && (
            <>
              <Grid item xs={6}>
                <Typography variant="body2" sx={{ mb: 0.5, fontWeight: 500 }}>
                  From
                </Typography>
                <TextField
                  type="date"
                  size="small"
                  fullWidth
                  value={dateFrom}
                  onChange={(e) => setDateFrom(e.target.value)}
                  InputLabelProps={{ shrink: true }}
                  sx={{
                    '& .MuiInputBase-input': {
                      fontSize: '14px',
                      py: 1,
                    },
                  }}
                />
              </Grid>
              <Grid item xs={6}>
                <Typography variant="body2" sx={{ mb: 0.5, fontWeight: 500 }}>
                  To
                </Typography>
                <TextField
                  type="date"
                  size="small"
                  fullWidth
                  value={dateTo}
                  onChange={(e) => setDateTo(e.target.value)}
                  InputLabelProps={{ shrink: true }}
                  sx={{
                    '& .MuiInputBase-input': {
                      fontSize: '14px',
                      py: 1,
                    },
                  }}
                />
              </Grid>
            </>
          )}
        </Grid>
      </Box>

      {/* Fixed buttons at bottom */}
      <Box sx={{
        pt: 2,
        borderTop: '1px solid',
        borderColor: 'divider',
        display: 'flex',
        justifyContent: 'flex-end',
        gap: 2
      }}>
        <Button
          variant="outlined"
          size="small"
          sx={{
            fontSize: "14px",
            borderRadius: "8px",
            px: 2,
            textTransform: "none",
            minWidth: 80
          }}
          onClick={handleReset}
        >
          Reset
        </Button>
        <Button
          variant="contained"
          size="small"
          sx={{
            fontSize: "14px",
            borderRadius: "8px",
            px: 2,
            textTransform: "none",
            minWidth: 80
          }}
          onClick={handleApply}
        >
          Apply
        </Button>
      </Box>
    </Card>
  );
};
const SearchBar = () => {
  const { anchorEl: anchorElFilter, openMenu: opneFilter, closeMenu: closeFilter } = useMenu();
  const location = useLocation();
  const navigate = useNavigate();
  const searchParams = new URLSearchParams(location.search);
  const [searchValue, setSearchValue] = useState("");
  useTheme()

  const { mode } = useTheme();

  // Sync searchValue with URL param when it changes
  useEffect(() => {
    setSearchValue(searchParams.get('q_itemName') || "");
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.search]);

  const handleSearchKeyDown = (e) => {
    if (e.key === 'Enter') {
      const newFilters = {
        ...filters,
        itemName: searchValue
      };
      setFilters(newFilters);
      updateUrlFilters(newFilters);
    }
  };

  // Get initial filters from URL or use defaults
  const getInitialFilters = () => ({
    type: searchParams.get('q_type') || "any",
    ownerType: searchParams.get('q_ownerType') || "anyone",
    specificOwner: searchParams.get('q_specificOwner') || "",
    itemName: searchParams.get('q_itemName') || "",
    location: searchParams.get('q_location') || "anywhere",
    dateModified: searchParams.get('q_dateModified') || "anytime",
    dateFrom: searchParams.get('q_dateFrom') || "",
    dateTo: searchParams.get('q_dateTo') || ""
  });

  const [filters, setFilters] = useState(getInitialFilters());

  const handleClearFilters = () => {
    setSearchValue("");
    const resetFilters = {
      type: "any",
      ownerType: "anyone",
      specificOwner: "",
      itemName: "",
      location: "anywhere",
      dateModified: "anytime",
      dateFrom: "",
      dateTo: ""
    };
    setFilters(resetFilters);
    updateUrlFilters(resetFilters);
  };

  const updateUrlFilters = (newFilters) => {
    const params = new URLSearchParams();

    if (newFilters.type !== "any") params.set('q_type', newFilters.type);
    if (newFilters.ownerType !== "anyone") params.set('q_ownerType', newFilters.ownerType);
    if (newFilters.specificOwner) params.set('q_specificOwner', newFilters.specificOwner);
    if (newFilters.itemName) params.set('q_itemName', newFilters.itemName);
    if (newFilters.location !== "anywhere") params.set('q_location', newFilters.location);
    if (newFilters.dateModified !== "anytime") params.set('q_dateModified', newFilters.dateModified);
    if (newFilters.dateFrom) params.set('q_dateFrom', newFilters.dateFrom);
    if (newFilters.dateTo) params.set('q_dateTo', newFilters.dateTo);

    navigate(`?${params.toString()}`, { replace: true });
  };

  return (
    <React.Fragment


    >
      <SearchWrapper
      >
        <IconWrapperLeft>
          {/* <SearchIcon fontSize="small" /> */}
          {
            mode === 'dark' ?
              <img src={IconLib.ggSearch} width={25} alt="" />
              :
              <img src={IconLib.ggSearchlm} width={25} alt="" />
          }
        </IconWrapperLeft>
        <FormControl fullWidth>
          <StyledInputBase
            value={searchValue}
            onChange={(e) => setSearchValue(e.target.value)}
            onKeyDown={handleSearchKeyDown}
            sx={{
              flex: 1, fontSize: 15,
              paddingLeft: 1,
            }}
            placeholder='Search in Files'

          />
        </FormControl>
        <IconWrapperRight>
          {searchValue && (
            <IconButton onClick={handleClearFilters}>
              <CloseIcon fontSize="28" />
            </IconButton>
          )}
          <IconButton
            sx={{ display: { xs: 'none', md: 'inline-flex' } }}
            onClick={opneFilter}
          >
            <TuneIcon fontSize="28" />
          </IconButton>
        </IconWrapperRight>
      </SearchWrapper>

      <Popover
        open={Boolean(anchorElFilter)}
        anchorEl={anchorElFilter}
        onClose={closeFilter}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}>
        <FilterBox
          initialFilters={filters}
          onFiltersChange={(newFilters) => {
            setFilters(newFilters);
            updateUrlFilters(newFilters);
          }}
          closeFilter={closeFilter}
        />
      </Popover>
    </React.Fragment>
  );
};
export default SearchBar;

